module.exports = __webpack_public_path__ + "img/24_23.894cdba2.png";